import React from 'react';

const LoadingScreen: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center bg-neutral">
    <p className="text-gray-600">Chargement...</p>
  </div>
);

export default LoadingScreen;
